export default __webpack_public_path__ + "static/media/about-us-1.4ace21a7.jpeg";